import { ReactNode, memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import { Divider } from '../../../../../../../common/divider';
import Typography from '../../../../../../../common/typography';

import { HEIGHT_OF_MOBILE_PAGE_TITLE } from '../../../../consts';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: HEIGHT_OF_MOBILE_PAGE_TITLE,
    paddingTop: theme.spacing(1)
  },
  title: {
    margin: theme.spacing(0, 2)
  }
}));

interface Props {
  children: ReactNode;
}

const PageTitle = ({ children }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box ml={3} flex={1}>
        <Divider color="white" />
      </Box>
      <Box className={classes.title}>
        <Typography size={16} color="white">
          {children}
        </Typography>
      </Box>
      <Box mr={3} flex={1}>
        <Divider color="white" />
      </Box>
    </Box>
  );
};

export default memo(PageTitle);
